import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider'

import { useTranslation } from 'react-multi-lang';
import { useContext, useEffect, useState } from 'react';

import StatisticCard from '../../components/statistic-card/StatisticCard';
import { Widgets ,AlignVerticalBottom ,AccountBalance,Loyalty} from '@mui/icons-material';

import StickyHeadTable from '../../components/Table/sticky_head_table';
import { havePermission } from '../../services/hoc/permissions';
import { Tooltip } from '@mui/material';
import { useNotification } from '../../services/usenotification';
import { useNavigate } from 'react-router-dom';

import PermissionBox from '../../components/no-permission/box';
import SettingContext from '../../services/context/setting-contentxt/setting-context';

import { useAPI } from '../../services/hoc/useAPI';
interface tableDataType {
  [key: string]: { [key: string]: any };
}
export const Main = () => {
const Endpoints = useAPI()
  const t = useTranslation();
  const {  alertError500 } = useNotification();
  const {isPc}=useContext(SettingContext)
  const navigate=useNavigate()
  const [statistics, setStatistics] = useState({
    income: 0,
    outcome: 0,
    purchases: 0,
    sells: 0,
  });
  const [topList, settopList] = useState<{
    top_clients: any[];
    top_products: any[];
    orders_list: any[];
  }>({ top_clients: [], top_products: [], orders_list: [] });

  const fetchIncome = () => {
    Endpoints.dashboard()
      .income()
      .then((res) => {
       
        setStatistics((pre) => ({ ...pre, income: res.data.data }));
      });
  };
  const fetchOutcome = () => {
    Endpoints.dashboard()
      .outcome()
      .then((res) => {
        
        setStatistics((pre) => ({ ...pre, outcome: res.data.data }));
      });
  };
  const fetchPurchases = () => {
    Endpoints.dashboard()
      .purchases()
      .then((res) => {
    
        setStatistics((pre) => ({ ...pre, purchases: res.data.data }));
      });
  };
  const fetchSells = () => {
    Endpoints.dashboard()
      .sells()
      .then((res) => {
     
        setStatistics((pre) => ({ ...pre, sells: res.data.data }));
      });
  };

  const fetchTopClients = () => {
    Endpoints.dashboard()
      .topClients({ counter: 5 })
      .then((res) => {
       
        if (res.data.data) {
         
          settopList((pre) => ({ ...pre, top_clients: res.data.data }));
        }
      })
      .catch((err: any) => {
        alertError500(err);
      });
  };
  
  const fetchTopProducts = () => {
    Endpoints.dashboard()
      .topProducts({ counter: 5 })
      .then((res) => {
      
        if (res.data.data) {
          settopList((pre) => ({ ...pre, top_products: res.data.data }));
        }
      })
      .catch((err) => alertError500(err));
  };
  const fetchOrdersList = () => {
    Endpoints.dashboard().ordersList({
      after: '1970/01/01',
      before: '2025/01/01',
      without_bill: 2,
      without_delivery_order: 2,
      without_job_order: 2,
    })
    .then(res=>settopList(pre=>({...pre ,orders_list:res.data.data})))
    .catch(err=>alertError500(err))
  };
  useEffect(() => {
    
    fetchIncome();
    fetchOutcome();
    fetchPurchases();
    fetchSells();
    fetchOrdersList();
    fetchTopClients();
    fetchTopProducts()
  }, []);
 
  const generateOrderData: () => tableDataType = () => {
    let data: tableDataType = {};
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
    topList.orders_list.length>0
      ? topList.orders_list.map((client, index) => {
          data[index] = {
            client_name: client.name,
            order_no:client.order_no,
            order_date: client.orders_date,
            total: client.total_paid+client.total_remain,
            total_paid: client.total_paid,
            total_remain:client.total_remain,
            net:client.net,
            vouchers:client.vouchers,
            orderstatus:client.status,
            orderstatus_date:client.status_date,

            actions: (
              <div className="show-on-hover">
                {havePermission('Show Client') ? (
                  <Tooltip title={t('info')}>
                    <i
                      className="icon-info"
                      onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation();
                        navigate(`/orders/${client.orders_id}`)
                      }}
                    />
                  </Tooltip>
                ) : (
                  ''
                )}
              </div>
            ),
          };
        })
      : null;

    return data;
  };
  const generateTopClients: () => tableDataType = () => {
    let data: tableDataType = {};
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    topList.top_clients.length>0
      ? topList.top_clients.map((client, index) => {
          data[index] = {
            client_name: client.client_name,
            "total_purchases": client.total_purchases,

            actions: (
              <div className="show-on-hover">
                {havePermission('Show Client') ? (
                  <Tooltip title={t('info')}>
                    <i
                      className="icon-info"
                      onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation();
                      }}
                    />
                  </Tooltip>
                ) : (
                  ''
                )}
              </div>
            ),
          };
        })
      : null;

    return data;
  };
  const generateTopMaterials: () => tableDataType = () => {
    let data: tableDataType = {};
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    topList.top_products.length>0
      ? topList.top_products.map((material, index) => {
          data[index] = {
            name: material.glass_name,
            sells: material.sold_area,

            actions: (
              <div className="show-on-hover">
                {havePermission('Show Client') ? (
                  <Tooltip title={t('info')}>
                    <i
                      className="icon-info"
                      onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation();
                        navigate('/materials',{state:{key:material.glass_name}})
                      }}
                    />
                  </Tooltip>
                ) : (
                  ''
                )}
              </div>
            ),
          };
        })
      : null;

    return data;
  };

 

  return (
    <Grid container padding={2}  overflow={'hidden'}
   >
      <Grid
        
        container
        size={12}
        justifyContent={'center'}
        
        maxHeight={'100vh'}
    
        >
        <Grid  container size={12}  
        marginBottom={4} columnGap={1} justifyContent={'space-between'}>
          <Grid  container size={12} columnSpacing={1} rowGap={1}   >
            <Grid  container  size ={{lg:3,sm:6,xs:3}} >
              <PermissionBox
              permission_key='View Key Figures'>

                <StatisticCard
                  cardBody={(statistics.sells ?? 0) + ' $'}
                  cardTitle={t('month_sales')}
                  cardIcon={<Loyalty />}
                  avatarColor={'lightblue'}
                />
              </PermissionBox>
            </Grid>
            <Grid  container size ={{lg:3,sm:6,xs:3}}>
            <PermissionBox
              permission_key='View Key Figures'>
              <StatisticCard
                cardBody={(statistics.purchases ?? 0) + ' $'}
                cardTitle={t('month_purchases')}
                cardIcon={<Widgets />}
                avatarColor={'lightgreen'}
              />
              </PermissionBox>
            </Grid>
            <Grid  container size ={{lg:3,sm:6,xs:3}}>
            <PermissionBox
              permission_key='View Key Figures'>
              <StatisticCard
                cardBody={(statistics.income ?? 0) + ' $'}
                cardTitle={t('month_income')}
                cardIcon={<AccountBalance />}
                avatarColor={'lightsalmon'}
              />
              </PermissionBox>
            </Grid>
            <Grid  container size ={{lg:3,sm:6,xs:3}}>
            <PermissionBox
              permission_key='View Key Figures'>
              <StatisticCard
                cardBody={(statistics.outcome ?? 0) + ' $'}
                cardTitle={t('month_outcome')}
                cardIcon={<AlignVerticalBottom />}
                avatarColor={'lightpink'}
              />
              </PermissionBox>
            </Grid>
          </Grid>

          {/* <Grid  container size={12}  columnGap={2} paddingY={2}  justifyContent={'space-between'}
          sx={{
            columnGap:{lg:2,xs:0},
            justifyContent:'space-between',
            paddingTop:'2rem'
          }}>
            <Grid  container size={5} paddingX={0}
             
            >
           
              <StickyHeadTable 
               headers={[t('client_name'), t('total_purchases'), '']}
               rows={generateTopClients()}
         
               maxHeight={isPc?'130px':'200px'}
               label={t("top_clients")}
               permission_key='View Tops'
              />
            
           
            </Grid>
            <Grid  container size={5} paddingX={0}>
         
              <StickyHeadTable 
                headers={[t('material_name'), t('sells'), '']}
                rows={generateTopMaterials()}
                maxHeight={isPc?'130px':'200px'}
                label={t("top_materials")}
                permission_key='View Tops'
              />
          
            </Grid>
          </Grid> */}
        </Grid>
        <Grid  container size={12}  display="flex" justifyContent="center" >
             <div className='action-bar' style={{'marginBottom':'0px'}}>
           <div className="actions" >
              <button className="add" onClick={() => { navigate('/orders/add_order') }}>
                    <i className="icon-plus"></i> {t('add_to_orders')}</button> 
            </div>

          </div>
        </Grid>
        <Grid container size={12}  flexGrow={1}>
         
          <StickyHeadTable
            permission_key='View Tops'
            label={t("orders_list")}
            headers={[
            t('client_name'),
            t('order_no'),
            t('order_date'),
            t('total'),
            t('total_paid'),
            t('total_remain'),
            t('net'),
            t("vouchers"),
            t('orderstatus'),
            t('orderstatus_date'),
            '',
          ]}
          rows={generateOrderData()}
          maxHeight={isPc?'350px':`${(window.innerHeight-170)/3}px`}
         
           />
     
      
         
        </Grid>
      </Grid>
    </Grid>
  );
};
